//@flow
import React, { Component } from 'react';
import { FooterDiv, CopyrightP } from './LayoutStyles';

type Props = {};

export default class Footer extends Component<Props> {
  render() {
    const year = new Date().getFullYear();
    return (
      <FooterDiv>
        <CopyrightP>
          &copy; All rights reserved - NetCents Technology Inc. {year}
        </CopyrightP>
      </FooterDiv>
    );
  }
}
